import { useState, useEffect } from 'react';
import { mentorService } from '../services/apiService';
import MentorList from '../components/MentorList';

const Mentors = () => {
  const [mentors, setMentors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchMentors = async () => {
    try {
      setLoading(true);
      const data = await mentorService.getAllMentors();
      setMentors(data);
    } catch (err) {
      setError(err.message || 'Failed to fetch mentors');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMentors();
  }, []);

  if (loading) {
    return <div className="text-center py-8">Loading mentors...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">{error}</div>;
  }

  return (
    <div>
      <h2 className="text-2xl font-medium text-gray-800 mb-6">Global Mentors Management</h2>
      <MentorList mentors={mentors} fetchMentors={fetchMentors} />
    </div>
  );
};

export default Mentors;